import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlogArticle } from '../../___LOGIC/___common/__interfaces/BlogArticle';
import { BlogManagerService } from 'src/app/___LOGIC/blog-manager.service';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css']
})
export class ArticleComponent implements OnInit {

  @Input() articleData;

  article: BlogArticle;

  constructor(private blogManager: BlogManagerService,private route: ActivatedRoute,) {
    if(!this.articleData){
      this.articleData = this.blogManager.getArticle(this.route.snapshot.paramMap.get('id'));
    }
  }

  ngOnInit(): void {
  }

}
  /* article: BlogArticle = {
    name: 'Sample Blog Article',
    description: 'This is a sample description for the blog article.',
    quote: 'This is a sample quote from the blog article.',
    paragraph1: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    paragraph2: `Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
    paragraph3: `Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.`,
    videoUrl: 'https://www.youtube.com/embed/samplevideo',
    imageUrl: 'https://via.placeholder.com/800x400',
    category: 'Web Development',
    country: 'USA',
    author: 'John Doe',
    authorImageUrl: 'https://via.placeholder.com/150',
    authorCareer: 'Senior Developer',
    notes: 'These are some additional notes about the article.',
    youtubeLink: 'https://youtube.com/sample',
    websiteLink: 'https://example.com',
    facebookLink: 'https://facebook.com/sample',
    instagramLink: 'https://instagram.com/sample',
    instagramLikes: 150,
    facebookLikes: 200,
    youtubeLikes: 300,
    tiktokLink: 'https://tiktok.com/sample',
    date: new Date(),
    created: new Date(),
    modified: new Date(),
    ranking: 5
  }; */

/* 

La autorización ETIAS es válida durante un período de 3 años o hasta la caducidad del pasaporte. No debe solicitarse cada vez que se quiera ir a Europa.
Lista de países que necesitan tramitar ETIAS
Albania
Antigua y Barbuda
Argentina
Australia
Bahamas
Barbados
Bosnia y Herzegovina
Brasil
Brunei
Canadá
Chile
Colombia
Costa Rica
Corea del Sur
Dominica
El Salvador
Emiratos Árabes Unidos
Estados Unidos
Georgia
Granada
Guatemala
Honduras
Hong Kong
Israel
Japón
Kiribati
Macedonia del Norte
Macao
Malasia
Islas
Marshall
Mauricio
México
Micronesia
Moldavia
Montenegro
Nueva Zelanda
Nicaragua
Palau
Panamá
Paraguay
Perú
Reino Unido
San Cristóbal y Nieves
Santa Lucía
San Vicente y las Granadinas
Samoa
Serbia
Seychelles
Singapur
Islas Salomón
Taiwan
Timor-Leste
Tonga
Trinidad y Tobago
Tuvalu
Ucrania
Uruguay
Venezuela
Para más información acerca de este o cualquier otro trámite de extranjería puedes contactar con nosotros a través de nuestra página web www.voyjaleas.com o a través del e-mail
 */